import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useAdvancedSearchTheme } from '@/shared/ui/search/AdvancedSearch/theme/useAdvancedSearchTheme';
import { useMemo } from 'react';
import { FilterOperator } from '@/shared/ui/search/AdvancedSearch/types/field.types';

interface IProps {
  value: FilterOperator | '';
  operators: readonly FilterOperator[];
  onChange: (operator: FilterOperator) => void;
  label?: string;
}

const OPERATOR_LABELS: Record<FilterOperator, string> = {
  CONTAINS: '포함',
  EQUALS: '일치',
  IN: '포함됨',
  RANGE_GTE: '이상',
  RANGE_LTE: '이하',
};

export function OperatorSelect({ value, operators, onChange, label = '연산자' }: IProps) {
  const { operatorSelectSx } = useAdvancedSearchTheme();
  const operatorItems = useMemo(() => {
    return operators.map((op) => ({
      operator: op,
      label: OPERATOR_LABELS[op],
    }));
  }, [operators]);

  return (
    <FormControl sx={operatorSelectSx} size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value as FilterOperator)}
      >
        {operatorItems.map(({ operator, label }) => (
          <MenuItem key={operator} value={operator}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
